import Vue from "vue";
import VueRouter from "vue-router";
import { i18n } from "@/services/i18n";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: require("./views/index.vue").default,
    meta: {
      breadcrumb: {
        icon: "mdi-home"
      }
    }
  },
  {
    path: "/users",
    name: "users",
    component: require("./views/user/index.vue").default,
    meta: {
      breadcrumb: {
        label: i18n.t("users"),
        parent: "home"
      }
    }
  },
  {
    path: "/users/create",
    component: require("./views/user/create.vue").default,
    meta: {
      breadcrumb: {
        parent: "users",
        label: i18n.t("create")
      }
    }
  },
  {
    path: "/users/:user/edit",
    component: require("./views/user/edit.vue").default,
    meta: {
      breadcrumb: {
        parent: "users",
        meta: "__user"
      }
    }
  },
  {
    path: "/account",
    component: require("@/shared/views/account/index.vue").default,
    meta: {
      breadcrumb: {
        parent: "home",
        label: i18n.t("account")
      }
    }
  },
  // Properties

  {
    path: "/properties",
    name: "properties",
    component: require("./views/property/index.vue").default,
    meta: {
      breadcrumb: {
        parent: "home",
        label: i18n.t("properties")
      }
    }
  },
  {
    path: "/works",
    name: "works",
    component: require("./views/works/index.vue").default,
    meta: {
      breadcrumb: {
        parent: "home",
        label: i18n.t("works_list")
      }
    }
  },
  {
    path: "/properties/archived",
    component: require("./views/property/base_archived.vue").default,
    meta: {
      breadcrumb: {
        parent: "properties",
        label: i18n.t("archived")
      }
    },
  },
  {
    path: "/properties/create",
    component: require("./views/property/base_create.vue").default,
    meta: {
      breadcrumb: {
        parent: "properties",
        label: i18n.t("create")
      }
    },
    children: [
      {
        path: "/",
        name: "properties.create",
        component: require("./views/property/create_property.vue").default,
        meta: {
          breadcrumb: {
            parent: "properties",
            label: i18n.t("create")
          }
        }
      },
      {
        path: ":property/pictures",
        name: "properties.create.pictures",
        component: require("./views/property/create_pictures.vue").default,
        meta: {
          breadcrumb: {
            parent: "properties",
            label: i18n.t("pictures")
          }
        }
      },
      {
        path: ":property/status",
        name: "properties.create.status",
        component: require("./views/property/create_status.vue").default,
        meta: {
          breadcrumb: {
            parent: "properties",
            label: i18n.t("statuses")
          }
        }
      }
    ]
  },
  {
    path: "/properties/:property",
    name: "properties.show",
    component: require("./views/property/show.vue").default,
    meta: {
      breadcrumb: {
        parent: "properties",
        meta: "__property"
      }
    },
    children: [
      { path: "", beforeEnter: (to, from, next) => next("details") },
      {
        path: "details",
        name: "properties.show.details",
        component: require("./views/property/_details.vue").default,
        meta: {
          breadcrumb: {
            parent: "properties.show",
            label: i18n.t("details").capitalize()
          }
        }
      },
      {
        path: "pictures",
        name: "properties.show.pictures",
        component: require("./views/property/_pictures.vue").default,
        meta: {
          breadcrumb: {
            parent: "properties.show",
            label: i18n.t("pictures").capitalize()
          }
        }
      },
      {
        path: "edit",
        name: "properties.edit",
        component: require("./views/property/edit.vue").default,
        meta: {
          breadcrumb: {
            parent: "properties.show",
            label: i18n.t("statuses")
          }
        }
      },
      {
        path: "statuses",
        name: "properties.show.statuses",
        component: require("./views/propertyStatus/index.vue").default,
        meta: {
          breadcrumb: {
            parent: "properties.show",
            label: i18n.t("statuses")
          }
        }
      },
      {
        path: "statuses/:propertyStatus",
        name: "properties.show.statuses.show",
        component: require("./views/propertyStatus/show.vue").default,
        meta: {
          breadcrumb: {
            parent: "properties.show.statuses",
            meta: "__property_status"
          }
        }
      },
      {
        path: "property-inspections",
        name: "properties.show.property-inspections",
        component: require("./views/propertyInspection/index.vue").default,
        meta: {
          breadcrumb: {
            parent: "properties.show",
            label: i18n.t("property_inspections")
          }
        }
      },
      {
        path: "property-inspections/create",
        component: require("./views/propertyInspection/create.vue").default,
        name: "properties.show.property-inspections.create",
        meta: {
          breadcrumb: {
            parent: "properties.show.property-inspections",
            label: i18n.t("create")
          }
        }
      },
      {
        path: "property-inspections/:propertyInspection",
        name: "properties.show.property-inspections.show",
        component: require("./views/propertyInspection/show.vue").default,
        meta: {
          breadcrumb: {
            parent: "properties.show.property-inspections",
            meta: "__property_inspection"
          }
        }
      },
      {
        path: "property-inspections/:propertyInspection/edit",
        component: require("./views/propertyInspection/edit.vue").default,
        name: "properties.show.property-inspections.edit",
        meta: {
          breadcrumb: {
            parent: "properties.show.property-inspections",
            label: i18n.t("edit")
          }
        }
      },
      {
        path: "application-files",
        name: "properties.show.application-files",
        component: require("./views/applicationFile/index.vue").default,
        meta: {
          breadcrumb: {
            parent: "properties.show",
            label: i18n.t("application_files")
          }
        }
      },
      {
        path: "application-files/create",
        name: "properties.show.application-files.create",
        component: require("./views/applicationFile/create.vue").default,
        meta: {
          breadcrumb: {
            parent: "properties.show.application-files",
            label: i18n.t("create")
          }
        }
      },
      {
        path: "application-files/:applicationFile",
        name: "properties.show.application-files.show",
        component: require("./views/applicationFile/show.vue").default,
        meta: {
          breadcrumb: {
            parent: "properties.show.application-files",
            meta: "__application_file"
          }
        },
      },
      {
        path: "application-files/:applicationFile/edit",
        component: require("./views/applicationFile/edit.vue").default,
        meta: {
          breadcrumb: {
            parent: "properties.show.application-files",
            label: i18n.t("edit")
          }
        }
      },
      {
        path: "application-files/:applicationFile/applicants/:applicant",
        name: "properties.show.application-files.show.applicants",
        component: require("./views/applicant/show.vue").default,
        meta: {
          breadcrumb: {
            parent: "properties.show.application-files.show",
            label: i18n.t("applicants")
          }
        }
      },
    ]
  },

  // Owners

  {
    path: "/owners",
    name: "owners",
    component: require("./views/owner/index.vue").default,
    meta: {
      breadcrumb: {
        parent: "home",
        label: i18n.t("owners")
      }
    }
  },
  {
    path: "/owners/create",
    component: require("./views/owner/create.vue").default,
    meta: {
      breadcrumb: {
        parent: "owners",
        label: i18n.t("create")
      }
    }
  },
  {
    path: "/owners/:owner",
    component: require("./views/owner/show.vue").default,
    meta: {
      breadcrumb: {
        parent: "owners",
        meta: "__owner"
      }
    },
    children: [
      {
        path: "/",
        name: "owners.show.details",
        component: require("./views/owner/_details.vue").default,
        meta: {
          breadcrumb: {
            parent: "owners.show",
            label: i18n.t("details").capitalize()
          }
        }
      },
      {
        path: "owner-businesses",
        name: "owners.show.owner.businesses",
        component: require("./views/ownerBusiness/index.vue").default,
        meta: {
          breadcrumb: {
            parent: "owners.show",
            label: i18n.t("owner_businesses")
          }
        }
      },
      {
        path: "owner-businesses/create",
        name: "owners.show.owner.businesses.create",
        component: require("./views/ownerBusiness/create.vue").default,
      },
      {
        path: "owner-businesses/:ownerBusiness",
        name: "owners.show.owner.businesses.show",
        component: require("./views/ownerBusiness/show.vue").default,
      },
      {
        path: "owner-businesses/:ownerBusiness/edit",
        name: "owners.show.owner.businesses.edit",
        component: require("./views/ownerBusiness/edit.vue").default,
      },
      {
        path: "contacts",
        name: "owners.show.contacts",
        component: require("./views/ownerContact/index.vue").default,
        meta: {
          breadcrumb: {
            parent: "owners.show",
            label: i18n.t("owner_contacts").capitalize()
          }
        }
      },
      {
        path: "contacts/create",
        name: "owners.show.contacts.create",
        component: require("./views/ownerContact/create.vue").default
      },
      {
        path: "contacts/:id",
        name: "owners.show.contacts.show",
        component: require("./views/ownerContact/show.vue").default
      },
      {
        path: "contacts/:id/edit",
        component: require("./views/ownerContact/edit.vue").default,
        name: "owners.show.contacts.edit"
      }
    ]
  },
  {
    path: "/owners/:owner/edit",
    component: require("./views/owner/edit.vue").default,
    meta: {
      breadcrumb: {
        parent: "owners.show",
        label: i18n.t("edit")
      }
    }
  },
  {
    path: "/property-logs",
    name: "property-logs",
    component: require("./views/propertyLog/index.vue").default,
    meta: {
      breadcrumb: {
        parent: "home",
        label: i18n.t("property_logs")
      }
    }
  },
  {
    path: "/terms-and-conditions",
    name: "terms_and_conditions",
    component: require("./views/termsAndConditions/index.vue").default,
    meta: {
      breadcrumb: {
        parent: "home",
        label: i18n.t("terms_and_conditions")
      }
    }
  },
  {
    path: "*",
    redirect: "/"
  }
];

const router = new VueRouter({
  routes,
  base: "admin",
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});


router.beforeEach((to, from, next) => {

  if (window.Laravel.user.role == "client") {

    if (!window.Laravel.user.is_onboarding_completed) {
      window.location.href = "/onboarding/" + window.Laravel.user.un_completed_onboarding_step;
      return false;
    }
  }

  next();
});


export default router;
